import {useQuery} from '@tanstack/react-query'
import {getFloatings} from '../../../apis/floating/getFloatings'
import {QueryCacheKeys} from '../../QueryKey'

const useQueryFloatings = (active: boolean) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.floating.getFloatings(active),
        queryFn: async () => {
            const {data, pageInfo} = await getFloatings(active)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data: data?.data, pageInfo: data?.pageInfo, refetch}
}

export default useQueryFloatings
